import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const NEXT = { applied: [["approved", "Approve"], ["declined", "Decline"]], approved: [["terms_sent", "Mark terms sent"], ["declined", "Decline"]], terms_sent: [["active", "Terms signed: activate"]], active: [], declined: [["approved", "Approve after all"]] };

const Row = ({ o, reload }) => {
  const [notes, setNotes] = useState("");
  const p = o.partnership;
  const set = async (status) => {
    try { await api.put(`/admin/partnerships/${o.id}`, { status, notes }); toast.success("Updated"); setNotes(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <li className="card p-5" data-testid={`partnership-row-${o.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2"><b>{o.name}</b><span className="caption">{p.status} · {p.equity_percent}% · subscription {o.subscription?.status || "none"}</span></div>
      <p className="mt-1 text-xs text-slate-500">Applied {fmtDate(p.applied_at)} by {p.applied_by}</p>
      <dl className="mt-3 grid gap-2 text-sm sm:grid-cols-2">
        {[["Company number", p.application?.company_number], ["Shareholders", p.application?.shareholders], ["Funding to date", p.application?.funding_to_date], ["Needs", p.application?.why]].map(([k, v]) => <div key={k}><dt className="text-xs text-slate-500">{k}</dt><dd>{v || "-"}</dd></div>)}
      </dl>
      {NEXT[p.status].length > 0 && <div className="mt-3 flex flex-wrap items-center gap-2">
        <input aria-label="Note to the business" className="input max-w-sm py-1 text-xs" placeholder="Note to the business (optional)" value={notes} onChange={(e) => setNotes(e.target.value)} />
        {NEXT[p.status].map(([s, l]) => <button key={s} onClick={() => set(s)} data-testid={`partnership-${o.id}-${s}`} className={s === "declined" ? "btn-ghost btn-sm" : "btn-teal btn-sm"}>{l}</button>)}
      </div>}
    </li>
  );
};

export const Partnerships = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/partnerships").then(({ data }) => setRows(data));
  useEffect(() => {
    load();
  }, []);
  if (!rows) return <p className="text-sm text-slate-500">Loading…</p>;
  return (
    <div data-testid="admin-partnerships">
      <p className="mb-3 text-sm text-slate-600">Approve an application, send the shareholder documents outside the site, then activate once they're signed. Full access needs an active partnership and a paid subscription.</p>
      {rows.length === 0 ? <p className="text-sm text-slate-500">No applications yet.</p> : <ul className="space-y-3">{rows.map((o) => <Row key={o.id} o={o} reload={load} />)}</ul>}
    </div>
  );
};
